<template>
  <a-card style="border: none; border-radius: 12px">
    <div slot="title">
      <span style="color: #011733">培训方案 / 新建培训方案 / </span>
      <span style="color: #9ba2ab">选择课程</span>
    </div>
    <div slot="extra">
      <a-button
        @click="uploadClassHandel()"
        icon="plus"
        style="background: #fff9f0; border: none; color: #ef9f22"
      >
        新建课程专题
      </a-button>
    </div>
    <div>
      <a-form layout="inline" style="margin-bottom: 20px">
        <a-form-item label="课程分类">
          <a-select
            style="width: 200px"
            placeholder="请选择课程分类"
            v-model="dataForm.classify"
            size="large"
            allowClear
            :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
          >
            <a-select-option
              v-for="v in classifySelect"
              :key="v.id"
              :value="v.id"
            >
              {{ v.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="课程名称">
          <a-input
            v-model="dataForm.name"
            placeholder="请输入课程名称"
            size="large"
          >
          </a-input>
        </a-form-item>
        <a-button type="primary" size="large" @click="getDataList_"
          >搜索</a-button
        >
        <!-- <a-button type="success" size="large" @click="tongbu"
          >同步公共文件</a-button
        > -->
      </a-form>
      <a-table
        filterMultiple
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
        rowKey="id"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onSelect: onSelect,
          onChange: onSelectChange,
          onSelectAll: onSelectAll,
          getCheckboxProps: getCheckboxProps,
        }"
      >
        <span slot="url" slot-scope="text, record">
          {{ record.belong == 1 ? "系统课程" : text }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button size="small" type="link" @click="showFiles(record)"
              >查看
            </a-button>
          </a-space>
        </span>
      </a-table>
      <a-pagination
        style="margin: 20px 0"
        :pageSizeOptions="pageSizeOptions"
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
      />
      <a-row type="flex" justify="space-between">
        <a-col>
          <div style="color: #011733; font-size: 18px">
            选择
            <span style="color: #0073ff">{{
              dataListSelections.length + selectClasses.length
            }}</span>
            个课程
          </div>
        </a-col>
        <a-col>
          <a-button @click="back">取消</a-button>
          <a-button type="primary" @click="confirm">确认添加课程</a-button>
        </a-col>
      </a-row>
    </div>
    <UploadClass ref="uploadClass" @ok="getDataList_"></UploadClass>
    <ShowFile ref="showFile"></ShowFile>
  </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import UploadClass from "./uploadClass";
import instance from "@/request/request";
import ShowFile from "./showfile";
export default {
  mixins: [viewModule],
  components: { UploadClass, ShowFile },
  props: {
    selectClasses: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      classifySelect: [],
      columns: [
        {
          title: "课程分类",
          dataIndex: "classify",
          key: "classify",
          align: "left",
          width: 200,
        },
        {
          title: "课程名称",
          dataIndex: "name",
          key: "name",
          align: "left",
        },
        {
          title: "文件地址",
          dataIndex: "url",
          key: "url",
          align: "left",
          scopedSlots: { customRender: "url" },
        },
        {
          title: "格式",
          dataIndex: "type",
          key: "type",
          align: "left",
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          align: "left",
          scopedSlots: { customRender: "action" },
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: "/trainClass/page",
      },
      dataForm: {
        classify: undefined,
        name: "",
      },
    };
  },
  mounted() {
    this.getClassifySelect();
  },
  methods: {
    getDataList_() {
      // this.getDataList();
      this.page = 1;
      this.query();
      this.getClassifySelect();
    },
    addOrUpdateHandle_() {},
    //新建课程
    uploadClassHandel() {
      this.$refs.uploadClass.init();
    },
    // tongbu() {
    //   instance.get("/trainClass/tongbu");
    // },
    //获取课程分类选择数据
    getClassifySelect() {
      instance.get("/trainClass/classifySelect").then((res) => {
        this.classifySelect = res.data;
      });
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: this.selectClasses.findIndex((v) => v.id == record.id) > -1,
          name: record.name,
        },
      };
    },
    //查看文件
    showFiles(record) {
      console.log(record);
      this.$refs.showFile.init(record);
    },
    //取消
    back() {
      this.$emit("changeType", 1);
    },
    //确认添加
    confirm() {
      this.$emit("confirm", this.dataListSelections);
      this.$emit("changeType", 1);
    },
  },
};
</script>

<style>
</style>